import React from 'react'
import moment from 'moment';
import Select from "react-select";

import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import StudentAppBar from '../StudentAppBar';
import StudentSideBar from "../StudentSideBar";
import './style.css'

import AdmissionApi from "../../Services/AdmissionApi";

class StudentProfile extends React.Component {

  state = {
    isOpen: window.innerWidth < 980 ? false : true,
    isEdit: false,
    allSubjects: [],
    allCategories: [],
    userId: null,
    firstName: '',
    lastName: '',
    fatherName: '',
    email: '',
    phone: '',
    school: '',
    lastClass: '',
    passingYear: '',
    dateOfBirth: '',
    subjects: [],
    myAlertCategories: [],
    errors: {
      firstName: '',
      lastName: '',
      fatherName: '',
      email: '',
      phone: '',
      school: '',
      lastClass: '',
      passingYear: '',
      dateOfBirth: '',
      subjects: '',
      myAlertCategories: '',
    }
  }

  cbSubjectList = (res) => {
    if (!res.data.success) return
    const _subjects = res.data._embedded.schoolsubject

    const allSubjects = _subjects.map(item => ({
      label: item.name,
      value: item.id
    }))

    this.setState({ allSubjects })
  }

  cbCategoryList = (res) => {
    if (!res.data.success) return
    const _categories = res.data._embedded.category

    const allCategories = _categories.map(item => ({
      label: item.name,
      value: item.id
    }))

    this.setState({ allCategories })
  }

  cbUserInfo = (newResponse) => {
    if (!newResponse.data.success) return

    const student = newResponse.data._embedded.students[0]

    if (student) {

      this.setState({
        userId: student.id,
        firstName: student.first_name,
        lastName: student.last_name,
        fatherName: student.father_name,
        email: student.email,
        phone: student.phone_number,
        school: student.school_name,
        lastClass: student.class,
        passingYear: student.batch,
        dateOfBirth: moment(student.date_of_birth).format('YYYY-MM-DD'),
        subjects: student.subjects,
        myAlertCategories: student.categories
      })
      localStorage.setItem(
        "categories",
        JSON.stringify(newResponse.data._embedded.students[0].categories)
      );
    }

  }

  UNSAFE_componentWillMount() {
    this.admissionsService = new AdmissionApi()
    const userId = localStorage.getItem("userId")

    this.admissionsService.GetData(
      this.cbSubjectList,
      "v1/students/school/subject"
    )

    this.admissionsService.GetData(
      this.cbCategoryList,
      "v1/students/alert/category"
    )

    this.admissionsService.GetData(
      this.cbUserInfo,
      "v1/students?user_id=" + userId
    )
  }

  toggleEdit = () => this.setState(state => ({ isEdit: !state.isEdit }))

  resetErrorMsg = (errorId) => {
    this.setState((preState) => ({
      errors: { ...preState.errors, [errorId]: "" },
    }))
  }

  handleFormFieldChange = (e) => {
    e.preventDefault()
    const { id, value } = e.target
    this.setState({
      [id]: value
    })

    this.resetErrorMsg(id)
  }

  handleSubjectsChange = (subjects) => {
    if (subjects && subjects.length <= 6) {
      this.setState({ subjects });
      this.setState((state) => ({
        errors: {
          ...state.errors,
          subjects: ''
        }
      }))
    } else {
      this.setState((state) => ({
        errors: {
          ...state.errors,
          subjects: 'You can only select 6 subjects max.'
        }
      }))
    }
  }

  handleCategoriesChange = (myAlertCategories) => {
    if (myAlertCategories && myAlertCategories.length <= 3) {
      this.setState({ myAlertCategories })
      this.setState((state) => ({
        errors: {
          ...state.errors,
          myAlertCategories: ''
        }
      }))
    } else {
      this.setState((state) => ({
        errors: {
          ...state.errors,
          myAlertCategories: 'You can only select 3 categories max.'
        }
      }))
    }
  }

  handleValidation = () => {
    let fields = this.state;
    let formIsValid = true;
    let errors = {
      firstName: '',
      lastName: '',
      fatherName: '',
      email: '',
      phone: '',
      school: '',
      lastClass: '',
      passingYear: '',
      dateOfBirth: '',
      subjects: '',
      myAlertCategories: '',
    }

    //Email
    if (!fields["email"]) {
      formIsValid = false;
      errors["email"] = "Cannot be empty";
    }

    if (fields['email'] && !fields["email"].match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
      formIsValid = false;
      errors["email"] = "Email is not valid";
    }

    //First_name
    if (!fields["firstName"]) {
      formIsValid = false;
      errors["firstName"] = "Cannot be empty";
    }

    if (fields["firstName"] && /[^A-Za-z \.]/.test(fields['firstName'])) {
      formIsValid = false;
      errors["firstName"] = "Special characters and numbers are not allowed";
    }

    //Last name
    if (!fields["lastName"]) {
      formIsValid = false;
      errors["lastName"] = "Cannot be empty";
    }

    if (fields["lastName"] && /[^A-Za-z \.]/.test(fields['lastName'])) {
      formIsValid = false;
      errors["lastName"] = "Special characters and numbers are not allowed";
    }

    //Father name
    if (!fields["fatherName"]) {
      formIsValid = false;
      errors["fatherName"] = "Cannot be empty";
    }

    if (fields["fatherName"] && /[^A-Za-z \.]/.test(fields['fatherName'])) {
      formIsValid = false;
      errors["fatherName"] = "Special characters and numbers are not allowed";
    }

    //Phone
    if (!fields["phone"]) {
      formIsValid = false;
      errors["phone"] = "Cannot be empty";
    }

    if (fields["phone"] && !fields["phone"].match(/^\d{10}$/)) {
      formIsValid = false;
      errors["phone"] = "Phone is not valid"
    }

    //School name
    if (!fields["school"]) {
      formIsValid = false;
      errors["school"] = "Cannot be empty";
    }

    if (fields["school"] && /[^A-Za-z \.]/.test(fields['school'])) {
      formIsValid = false;
      errors["school"] = "Special characters and numbers are not allowed";
    }

    //Last Class
    if (!fields["lastClass"]) {
      formIsValid = false;
      errors["lastClass"] = "Cannot be empty";
    }

    //Passing Year
    if (!fields["passingYear"]) {
      formIsValid = false;
      errors["passingYear"] = "Cannot be empty";
    }

    //date_of_birth
    if (!fields["dateOfBirth"]) {
      formIsValid = false;
      errors["dateOfBirth"] = "Cannot be empty";
    }

    // subjects
    if (!fields["subjects"].length) {
      formIsValid = false;
      errors["subjects"] = "Cannot be empty";
    }

    // myAlertCategories
    if (!fields["myAlertCategories"].length) {
      formIsValid = false;
      errors["myAlertCategories"] = "Cannot be empty";
    }

    errors["responseError"] = "";

    this.setState({ errors });
    return formIsValid;
  }

  onSubmit = () => {
    if (!this.handleValidation()) return

    const {
      userId,
      firstName,
      lastName,
      fatherName,
      school,
      lastClass,
      passingYear,
      dateOfBirth,
      subjects,
      myAlertCategories,
    } = this.state
    const schoolCode = JSON.parse(localStorage.getItem('userInfo')).school_code

    let obj = {
      id: userId,
      school_code: schoolCode,
      first_name: firstName.trim(),
      last_name: lastName.trim(),
      father_name: fatherName.trim(),
      school_name: school.trim(),
      class: lastClass,
      batch: passingYear,
      date_of_birth: dateOfBirth,
      subjects: subjects,
      categories: myAlertCategories,
    }

    this.admissionsService.updateCredentials(
      this.toggleEdit,
      obj,
      "v1/students"
    )
  }

  toggleSidebar = () => {
    this.setState(state => ({ isOpen: !state.isOpen }))
  }

  handleRequestChange = (isOpen) => {
    this.setState({ isOpen })
  }

  render() {

    const {
      errors,
      allSubjects,
      allCategories,
      isEdit,
      firstName,
      lastName,
      fatherName,
      email,
      phone,
      school,
      lastClass,
      passingYear,
      dateOfBirth,
      subjects,
      myAlertCategories,
      isOpen
    } = this.state

    return (
      <MuiThemeProvider>
        <div className="dash-container">
          <StudentSideBar isOpen={isOpen} handleRequestChange={this.handleRequestChange} />

          <div className="dash-content">
            <StudentAppBar title="My Profile" toggleSidebar={this.toggleSidebar} router={this.props.router} />
            <div className="container">
              <div className="mt-3 mb-3 text-right">
                <button className='btn btn--primary' onClick={this.toggleEdit}>{isEdit ? 'Cancel' : 'Edit'}</button>
                <button className={`btn btn--new ml-2 ${!isEdit && 'd-none'}`} onClick={this.onSubmit}>Save</button>
              </div>
              <div className="dash-box mb-4">
                <div className='row'>
                  <div className='col-sm-12 col-lg-6'>
                    <div className={`form-group ${errors["firstName"] && 'm-0'}`}>
                      <label>First Name</label>
                      <input
                        type="text"
                        id="firstName"
                        readOnly={!isEdit}
                        className="form-control alert-filter__input"
                        placeholder="First Name"
                        value={firstName}
                        onChange={this.handleFormFieldChange}
                      />
                    </div>
                    <span style={{ color: "red", fontFamily: "italian" }}>
                      {errors["firstName"]}
                    </span>
                  </div>
                  <div className='col-sm-12 col-lg-6'>
                    <div className={`form-group ${errors["lastName"] && 'm-0'}`}>
                      <label>Last Name</label>
                      <input
                        type="text"
                        id="lastName"
                        readOnly={!isEdit}
                        className="form-control alert-filter__input"
                        placeholder="Last Name"
                        value={lastName}
                        onChange={this.handleFormFieldChange}
                      />
                    </div>
                    <span style={{ color: "red", fontFamily: "italian" }}>
                      {errors["lastName"]}
                    </span>
                  </div>
                  <div className='col-sm-12 col-lg-6'>
                    <div className={`form-group ${errors["fatherName"] && 'm-0'}`}>
                      <label>Father’s Name</label>
                      <input
                        type="text"
                        id="fatherName"
                        readOnly={!isEdit}
                        className="form-control alert-filter__input"
                        placeholder="Father’s Name"
                        value={fatherName}
                        onChange={this.handleFormFieldChange}
                      />
                    </div>
                    <span style={{ color: "red", fontFamily: "italian" }}>
                      {errors["fatherName"]}
                    </span>
                  </div>
                  <div className='col-sm-12 col-lg-6'>
                    <div className={`form-group ${errors["dateOfBirth"] && 'm-0'}`}>
                      <label>Date of birth</label>
                      <input
                        type="date"
                        id="dateOfBirth"
                        readOnly={!isEdit}
                        max={moment().format('YYYY-MM-DD')}
                        className="form-control alert-filter__input"
                        value={dateOfBirth}
                        onChange={this.handleFormFieldChange}
                      />
                    </div>
                    <span style={{ color: "red", fontFamily: "italian" }}>
                      {errors["dateOfBirth"]}
                    </span>
                  </div>
                  <div className='col-sm-12 col-lg-6'>
                    <div className={`form-group ${errors["email"] && 'm-0'}`}>
                      <label>Email</label>
                      <input
                        type="text"
                        id="email"
                        disabled
                        className="form-control alert-filter__input"
                        placeholder="Email"
                        value={email}
                        onChange={this.handleFormFieldChange}
                      />
                    </div>
                    <span style={{ color: "red", fontFamily: "italian" }}>
                      {errors["email"]}
                    </span>
                  </div>
                  <div className='col-sm-12 col-lg-6'>
                    <div className={`form-group ${errors["phone"] && 'm-0'}`}>
                      <label>Mobile No.</label>
                      <input
                        type="text"
                        id="phone"
                        disabled
                        className="form-control alert-filter__input"
                        placeholder="phone"
                        value={phone}
                        onChange={this.handleFormFieldChange}
                      />
                    </div>
                    <span style={{ color: "red", fontFamily: "italian" }}>
                      {errors["phone"]}
                    </span>
                  </div>
                  <div className='col-sm-12'>
                    <div className={`form-group ${errors["subjects"] && 'm-0'}`}>
                      <label>Subjects (Max 6)</label>
                      <Select
                        style={{ width: "100%;" }}
                        isMulti={true}
                        isDisabled={!isEdit}
                        value={subjects}
                        onChange={this.handleSubjectsChange}
                        options={allSubjects}
                        placeholder='Select your subjects*'
                      />
                    </div>
                    <span style={{ color: "red", fontFamily: "italian" }}>
                      {errors["subjects"]}
                    </span>
                  </div>
                  <div className='col-sm-12'>
                    <div className={`form-group ${errors["myAlertCategories"] && 'm-0'}`}>
                      <label>Course Categories (Max 3)</label>
                      <Select
                        style={{ width: "100%;" }}
                        isMulti={true}
                        isDisabled={!isEdit}
                        value={myAlertCategories}
                        onChange={this.handleCategoriesChange}
                        options={allCategories}
                        placeholder='Select your course categories*'
                      />
                    </div>
                    <span style={{ color: "red", fontFamily: "italian" }}>
                      {errors["myAlertCategories"]}
                    </span>
                  </div>
                  <div className='col-sm-12'>
                    <div className={`form-group ${errors["school"] && 'm-0'}`}>
                      <label>School</label>
                      <input
                        type="text"
                        id="school"
                        readOnly={!isEdit}
                        className="form-control alert-filter__input"
                        placeholder="School"
                        value={school}
                        onChange={this.handleFormFieldChange}
                      />
                    </div>
                    <span style={{ color: "red", fontFamily: "italian" }}>
                      {errors["school"]}
                    </span>
                  </div>
                  <div className='col-sm-12 col-lg-6'>
                    <div className={`form-group ${errors["lastClass"] && 'm-0'}`}>
                      <label>Class</label>
                      <input
                        type="text"
                        id="lastClass"
                        readOnly={!isEdit}
                        className="form-control alert-filter__input"
                        placeholder="Class"
                        value={lastClass}
                        onChange={this.handleFormFieldChange}
                      />
                    </div>
                    <span style={{ color: "red", fontFamily: "italian" }}>
                      {errors["lastClass"]}
                    </span>
                  </div>
                  <div className='col-sm-12 col-lg-6'>
                    <div className={`form-group ${errors["passingYear"] && 'm-0'}`}>
                      <label>Year of passing class 12<sup>th</sup></label>
                      <select
                        className="form-control alert-filter__input"
                        id="passingYear"
                        value={passingYear}
                        onChange={this.handleFormFieldChange}
                        disabled={!isEdit}
                      >
                        <option value=''>Choose...</option>
                        {Array.from(Array(10)).map((x, i) => (
                          <option value={new Date().getFullYear() + i}>{new Date().getFullYear() + i}</option>
                        ))}
                      </select>
                    </div>
                    <span style={{ color: "red", fontFamily: "italian" }}>
                      {errors["passingYear"]}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div >
      </MuiThemeProvider >
    )
  }

}

export default StudentProfile



/** WEBPACK FOOTER **
 ** ./src/components/StudentProfile/index.js
 **/